import { Box, Button, Grid, Typography, Stack, TextField } from "@mui/material";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import {
    ListBox,
    ListBoxToolbar,
    processListBoxData,
    processListBoxDragAndDrop
} from "@progress/kendo-react-listbox";
import { Tooltip as KendoTooltip } from "@progress/kendo-react-tooltip";
import { Button as KendoReactButton } from "@progress/kendo-react-buttons";
import dataStorageService from "../../../../shared/common-utilities/services/DataStorageService";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import { useState, useEffect } from "react";
import { filterBy } from "@progress/kendo-data-query";
import WindowComponent from "../Window/WindowComponent";
import AlertComponent from "../../../../shared/common-utilities/common/AlertComponent";
import i18_en from '../../../../jsonStore/i18_en.json';

let service = getSetDataService();
let storageService = dataStorageService();
let tempSortKeyName = '';

const SortColumnHeaderItem = (props) => {
    let { dataItem, selected, ...others } = { ...props };
    // const sequenceNum = colMultiFilter.sortColumnsData.map(data => data.field).indexOf(dataItem.field) + 1;
    return (
        <li {...others}>
            <Stack
                direction="row"
                spacing={1}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%"
                }}
            >
                <span style={{ width: "110px" }}>{dataItem.title}</span>
                <span>{dataItem.order}</span>
                <span>{dataItem.groupBy ? 'True' : 'False'}</span>
                {/* <span>{sequenceNum}</span> */}
            </Stack>
        </li>
    );
};

const SortColumnChooserPopUp = (props) => {
    const { gridFlagVal, openModalSort, setOpenModalSort, columnMultiFilter, filterSortArr,
        gridTempColumnList, isChild, sendDataToParent, sortKeyViews,
        myGroupByColumnVal, myFreezeColumnVal, nonSortableColumnData } = { ...props };

    const SELECTED_FIELD = "selected";

    const [sortColumnDirToggle, setSortColumnDirToggle] = useState(true);
    const [newSortKeyName, setNewSortKeyName] = useState("");
    const [isNewSortKeyView, setIsNewSortKeyView] = useState(false);
    const [openModalCurSortKey, setOpenModalCurSortKey] = useState(false);
    const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState(false);
    const [currSortKeyValue, setCurrSortKeyValue] = useState("");
    const [multiSelectColData, setMultiSelectColData] = useState([]);
    const [listBoxHeight, setListBoxHeight] = useState(580);
    const [filterWindowPos, setFilterWindowPos] = useState({ left: 0, top:  0, width: 680, height: 585 });
    const [isVisibleWindow, setIsVisibleWindow] = useState(false);
    const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = useState(false);
    const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
    let [colMultiFilter, setColMultiFilter] = useState(columnMultiFilter);
    const [groupByColumnVal, setGroupByColumnVal] = useState(myGroupByColumnVal);
    const [freezeColumnVal, setFreezeColumnVal] = useState(myFreezeColumnVal);
    const [selectedExistingKeyName, setSelectedExistingKeyName] = useState('');
    const isBtnDisabled = colMultiFilter.sortColumnsData?.length > 0 ? false : true;

    useEffect(() => {
        if (openModalSort) {
            setIsVisibleWindow(true);
            setListBoxHeight(580);
            service.setWindowInitialPosition(680, 585, setFilterWindowPos);

            const sortArray = filterSortArr.sortArray ? filterSortArr.sortArray : [];
            const updatedMovTableColumns = gridTempColumnList?.filter(item =>
                !sortArray.map(obj => obj.field).includes(item.field) &&
                !nonSortableColumnData.includes(item.field)
            );

            const updatedSortColumnsData = sortArray.map(({ field, dir }) => {
                const column = gridTempColumnList.find(item => item.field === field);
                // Update the order property
                return column ?  { ...column, order: dir } : null;
            }).filter(Boolean);

            setColMultiFilter({
                ...colMultiFilter,
                sortColumnsData: updatedSortColumnsData,
                movTableColumns: updatedMovTableColumns
            });
            setCurrSortKeyValue("");
        }
    }, [openModalSort])

    useEffect(() => {
        setMultiSelectColData(gridTempColumnList?.map(item => item.title)?.slice())
    }, [gridTempColumnList])

    // sort columns dir change - asc/desc
    const sortColumnDirChange = () => {
        setSortColumnDirToggle(!sortColumnDirToggle);
        const sortColumnDir = sortColumnDirToggle ? "desc" : "asc";
        const index = colMultiFilter.sortColumnsData.findIndex(obj => {
            return obj.selected === true;
        });
        if (index != -1) {
            colMultiFilter.sortColumnsData[index].order = sortColumnDir;
        }

        setColMultiFilter({
            ...colMultiFilter,
            sortColumnsData: colMultiFilter.sortColumnsData
        });
    };

    const multiSelectColFilterChange = (event) => {
        setMultiSelectColData(filterBy(gridTempColumnList?.map(item => item.title)?.slice(), event.filter));
    };

    // add new sortKey view
    const onAddCurrentSortKey = () => {
        setIsNewSortKeyView(true);
        setOpenModalCurSortKey(true);
    };

    // edit current sortKey view
    const onEditCurrentSortKey = () => {
        setNewSortKeyName(currSortKeyValue);
        setSelectedExistingKeyName(currSortKeyValue);
        setIsNewSortKeyView(false);
        setOpenModalCurSortKey(true);
        tempSortKeyName = currSortKeyValue;
    };

    const closePopUpSaveSortKey = () => {
        setOpenModalCurSortKey(false);
        setNewSortKeyName("");
        tempSortKeyName = '';
    };

    const closeDeleteConfirmationModal = () => {
        setOpenDeleteConfirmationModal(false);
    };

    // default sort key dropdown value
    const handleDropdownChange = event => {
        const selectedSortKey = event.target.value;
        setCurrSortKeyValue(selectedSortKey);
        const filteredViewsData = sortKeyViews?.filter(
            data => data.sortKeyName === selectedSortKey
        );
        const data = filteredViewsData?.[0]?.data?.map(data => data.field);

        const updatedMovTableColumns = gridTempColumnList?.filter(item => {
            if (!data?.includes(item.field)) {
                return item;
            }
        });
        setColMultiFilter({
            ...colMultiFilter,
            sortColumnsData: filteredViewsData[0].data,
            movTableColumns: updatedMovTableColumns
        });
    };

    const handleMultiSelectDropdown = event => {
        setFreezeColumnVal([...event.value]);
    };

    const onGroupByMultiSelectDropdown = event => {
        setGroupByColumnVal([...event.value]);
    };

    const sortColumnsOnItemClick = (event, data, connectedData) => {
        setColMultiFilter({
            ...colMultiFilter,
            [data]: colMultiFilter[data].map(item => {
                if (item.title === event.dataItem.title) {
                    item[SELECTED_FIELD] = !item[SELECTED_FIELD];
                } else if (!event.nativeEvent.ctrlKey) {
                    item[SELECTED_FIELD] = false;
                }
                return item;
            }),
            [connectedData]: colMultiFilter[connectedData].map(item => {
                item[SELECTED_FIELD] = false;
                return item;
            })
        });
    };

    const sortColumnsOnToolBarClick = (e) => {
        let toolName = e.toolName || '';
        let data = processListBoxData(colMultiFilter.sortColumnsData, colMultiFilter.movTableColumns, toolName, SELECTED_FIELD);
        setColMultiFilter({
            ...colMultiFilter,
            sortColumnsData: data.listBoxOneData,
            movTableColumns: data.listBoxTwoData
        });
    };

    const sortColumnsOnDragStart = e => {
        setColMultiFilter({
            ...colMultiFilter,
            draggedItem: e.dataItem
        });
    };

    const sortColumnsOnDrop = e => {
        let data = processListBoxDragAndDrop(
            colMultiFilter.sortColumnsData,
            colMultiFilter.movTableColumns,
            colMultiFilter.draggedItem,
            e.dataItem,
            "title"
        );
        setColMultiFilter({
            ...colMultiFilter,
            sortColumnsData: data.listBoxOneData,
            movTableColumns: data.listBoxTwoData
        });
    };

    const saveSortColumnsData = () => {
        // save settings Sort data to localStorage
        const views = storageService.getLocalStorageData(gridFlagVal + 'Savedview');
        const updatedRows = views ? JSON.parse(views) : initialSavedViewObj;
        const saveSettingsSelectedColumns = {
            sortColumnsData: colMultiFilter?.sortColumnsData,
            movTableColumns: colMultiFilter?.movTableColumns,
            freezeColumnVal: freezeColumnVal,
            groupByColumnVal: groupByColumnVal
        };

        updatedRows[gridFlagVal].settingsColumn = saveSettingsSelectedColumns;
        storageService.setLocalStorageData(gridFlagVal + 'Savedview', JSON.stringify(updatedRows));

        sendDataToParent({ groupByColumnVal: groupByColumnVal, freezeColumnVal: freezeColumnVal, colMultiFilter: colMultiFilter }, 'sortColumnsData');
        setOpenModalSort(false);
    };

    const clearSettings = (e) => {
        setFreezeColumnVal([]);
        setGroupByColumnVal([]);
        setColMultiFilter({
            ...colMultiFilter,
            sortColumnsData: [],
            movTableColumns: gridTempColumnList
        });
    }

    const closePopupFilter = () => {
        setOpenModalSort(false);
        // Set the sort columns based on user selection from localStorage.
        const views = storageService.getLocalStorageData(gridFlagVal + 'Savedview');
        const updatedRows = views ? JSON.parse(views) : initialSavedViewObj;
        setColMultiFilter({
            ...colMultiFilter,
            sortColumnsData:  updatedRows[gridFlagVal]?.settingsColumn?.sortColumnsData,
            movTableColumns: updatedRows[gridFlagVal]?.settingsColumn?.movTableColumns
        });
        setFreezeColumnVal([...updatedRows[gridFlagVal].settingsColumn.freezeColumnVal]);
        setGroupByColumnVal([...updatedRows[gridFlagVal].settingsColumn.groupByColumnVal]);
    };

    // save new/existing sortKey view
    const saveNewViewSortKey = () => {
        setNewSortKeyName(tempSortKeyName);
        if (tempSortKeyName?.trim() !== "") {
            const viewsData = storageService.getLocalStorageData(gridFlagVal + 'Savedview');
            let updatedViews = viewsData ? JSON.parse(viewsData) : initialSavedViewObj;

            const isExistSortKey = updatedViews[gridFlagVal].sortings.filter(e => e.sortKeyName === tempSortKeyName);
            if (isExistSortKey?.length > 0 && tempSortKeyName !== selectedExistingKeyName) {
                setErrorSnackbarMessage(i18_en.sortKeyAlreadyExists);
                setIsErrorSnackbarOpen(true);
                setNewSortKeyName("");
                tempSortKeyName = '';
                return null;
            }

            if (isNewSortKeyView) {
                //add new sortKey view
                updatedViews[gridFlagVal].sortings.push({
                    sortKeyName: tempSortKeyName,
                    data: colMultiFilter.sortColumnsData
                });
            } else {
                //update sortKey view
                const index = updatedViews[gridFlagVal].sortings.findIndex(obj => {
                    return obj.sortKeyName === currSortKeyValue;
                });
                updatedViews[gridFlagVal].sortings[index].sortKeyName = tempSortKeyName;
                updatedViews[gridFlagVal].sortings[index].data = colMultiFilter.sortColumnsData;
            }

            storageService.setLocalStorageData(gridFlagVal + "Savedview", JSON.stringify(updatedViews));
            sendDataToParent({ views: updatedViews, sortKeyViews: updatedViews[gridFlagVal].sortings || [] }, 'saveNewViewSortKey');
            setNewSortKeyName("");
            setCurrSortKeyValue(tempSortKeyName);
            closePopUpSaveSortKey();
        } else {
            setErrorSnackbarMessage(i18_en.selectValidSortKeyName);
            setIsErrorSnackbarOpen(true);
            setNewSortKeyName("");
            tempSortKeyName = '';
            return;
        }
    };

    // delete saved sortKey view
    const deleteSavedSortKeyView = currSortKeyValue => {
        if (currSortKeyValue) {
            const viewsData = storageService.getLocalStorageData(gridFlagVal + 'Savedview');

            let updatedViews = viewsData
                ? JSON.parse(viewsData)
                : { [gridFlagVal]: service.initialViewsObj };
            if (updatedViews) {
                const parsedData = updatedViews[gridFlagVal].sortings.filter(
                    x => x.sortKeyName != currSortKeyValue
                );
                updatedViews[gridFlagVal].sortings = parsedData;
                storageService.setLocalStorageData(gridFlagVal + "Savedview", JSON.stringify(updatedViews));

                sendDataToParent({ views: updatedViews, parsedData: parsedData}, 'deleteSavedSortKeyView');
                setCurrSortKeyValue("");
                setColMultiFilter({
                    ...colMultiFilter,
                    sortColumnsData: [],
                    movTableColumns: gridTempColumnList
                });
                setOpenDeleteConfirmationModal(false);
            }
        }
    };

    const SaveCurrentSortKeyData = (prop) => {
        if (prop?.sendDataToParent) {
            setTimeout(() => {
                prop.sendDataToParent('messagePopup');
            }, 100);
        }

        return (
            <Box
                sx={{
                    bgcolor: "background.paper",
                    p: 2
                }}
                id="messagePopup"
            >
                <TextField
                    label="New Sort Key Name"
                    defaultValue={newSortKeyName}
                    onChange={e => { tempSortKeyName = e.target.value }}
                    fullWidth
                    required
                />
            </Box>
        )
    }

    const DeleteConfirmationComponent = (prop) => {
        if (prop?.sendDataToParent) {
            setTimeout(() => {
                prop.sendDataToParent('deletePopup');
            }, 100);
        }

        return (
            <Box sx={{ width: 350, bgcolor: "background.paper", p: 3 }} id="deletePopup">
                <Typography variant="h6" sx={{ pr: .5, justifyContent: 'center', fontSize: '15px' }}>{i18_en.deleteConfirmationMessage}{" "}<span style={{ fontWeight: "bold" }}>{currSortKeyValue}</span> item?</Typography>
            </Box>
        )
    }

    const RenderActionButtons = (props) => {
        return (
            <>
                {props?.flag === 'deleteConfirmModal' ?
                    (
                        <>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={closeDeleteConfirmationModal}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={() => deleteSavedSortKeyView(currSortKeyValue)}
                            >
                                Confirm
                            </Button>
                        </>
                    ) :
                    (
                        <Button
                            variant="outlined"
                            onClick={saveNewViewSortKey}
                        >
                            {isNewSortKeyView ? "Save" : "Update"}
                        </Button>
                    )
                }
            </>
        )
    }

    const onMoveWindow = (event) => {
        service.onMoveWindow(event, filterWindowPos, setFilterWindowPos);
    };

    const onResizeWindow = (event) => {
        service.onResizeWindow(event, setFilterWindowPos);
        setListBoxHeight(event.height);
    }

    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setIsErrorSnackbarOpen(false);
    };

    return (
        <>
            {(openModalSort && isVisibleWindow) && <Window title={"Sort Columns Chooser"} className='kendo-popup' modal={true} initialWidth={680} initialHeight={585} minWidth={680} minHeight={585} onClose={closePopupFilter} left={filterWindowPos.left} top={filterWindowPos.top} onMove={onMoveWindow} onResize={onResizeWindow} maximizeButton={() => { return null }} doubleClickStageChange={false}>
                <Grid sx={{ padding: 0, height: 'calc(100% - 50px)', gridTemplateRows: 'auto auto auto auto 1fr', display: 'grid' }}>
                    <Box
                        direction="row"
                        sx={{ flexGrow: 0, marginBottom: 1, display: "flex" }}
                    >
                        <Typography variant="body2" sx={{ width: "155px" }}>
                            Default Sort Key:
                        </Typography>
                        <Typography variant="body2">(none) </Typography>
                    </Box>
                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}
                    >
                        <Typography variant="body2" sx={{ width: "150px" }}>
                            Current Sort Key:
                        </Typography>
                        <DropDownList
                            data={
                                sortKeyViews && sortKeyViews.map(item => item.sortKeyName)
                            }
                            value={currSortKeyValue}
                            style={{ width: "40%" }}
                            onChange={handleDropdownChange}
                        />
                        <span>
                            <Button
                                variant="outlined"
                                size="large"
                                sx={{ m: 0, p: 0 }}
                                color="primary"
                                disabled={isBtnDisabled}
                                onClick={onAddCurrentSortKey}
                            >
                                <AddIcon />
                            </Button>
                        </span>
                        <span>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ m: 0, p: 0 }}
                                color="primary"
                                disabled={!currSortKeyValue ? true : false}
                                onClick={onEditCurrentSortKey}
                            >
                                <EditIcon />
                            </Button>
                        </span>
                        <span>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ m: 0, p: 0 }}
                                color="primary"
                                disabled={!currSortKeyValue ? true : false}
                                onClick={() => setOpenDeleteConfirmationModal(true)}
                            >
                                <CloseIcon />
                            </Button>
                        </span>
                    </Stack>
                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}
                    >
                        <Typography variant="body2" sx={{ width: "150px" }}>
                            Freeze Columns:
                        </Typography>
                        <MultiSelect
                            data={multiSelectColData}
                            value={freezeColumnVal}
                            style={{ width: "60%" }}
                            onChange={handleMultiSelectDropdown}
                            placeholder="Please select ..."
                            autoClose={false}
                            filterable={true}
                            onFilterChange={multiSelectColFilterChange}
                            onClose={(e)=>{setMultiSelectColData(gridTempColumnList?.map(item => item.title)?.slice())}}
                        />
                    </Stack>
                    {!isChild && <Stack
                        direction="row"
                        spacing={1}
                        sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}
                    >
                        <Typography variant="body2" sx={{ width: "150px" }}>
                            GroupBy Columns:
                        </Typography>
                        <MultiSelect
                            data={multiSelectColData}
                            value={groupByColumnVal}
                            style={{ width: "60%" }}
                            onChange={onGroupByMultiSelectDropdown}
                            placeholder="Please select ..."
                            autoClose={false}
                            filterable={true}
                            onFilterChange={multiSelectColFilterChange}
                            onClose={(e)=>{setMultiSelectColData(gridTempColumnList?.map(item => item.title)?.slice())}}
                        />
                    </Stack>}
                    <Stack direction="row" spacing={1} className="customListBox">
                        <Box sx={{ width: "50%" }}>
                            <Typography
                                variant="body2"
                                gutterBottom
                                sx={{ color: "primary.main", fontWeight: "bold" }}
                            >
                                Sort Columns
                            </Typography>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "88%",
                                    backgroundColor: "lightgray"
                                }}
                            >
                                <span style={{ width: "110px", pl: 1 }}>Columns Name</span>
                                <span>Order</span>
                                <span>GroupBy</span>
                                {/* <span>Seq.</span> */}
                            </Stack>
                            <ListBox
                                style={{ height: `${listBoxHeight - 295}px`, width: "100%" }}
                                data={colMultiFilter.sortColumnsData}
                                textField="title"
                                selectedField={SELECTED_FIELD}
                                onItemClick={e =>
                                    sortColumnsOnItemClick(
                                        e,
                                        "sortColumnsData",
                                        "movTableColumns"
                                    )
                                }
                                onDragStart={sortColumnsOnDragStart}
                                onDrop={sortColumnsOnDrop}
                                item={SortColumnHeaderItem}
                                // item={(event) => { return <SortColumnHeaderItem colMultiFilter={colMultiFilter} { ...event } />}}
                                toolbar={() => {
                                    return (
                                        <div>
                                            <KendoTooltip anchorElement="pointer" position="top" className="custom-tooltip">
                                                <KendoReactButton
                                                    title="Change Order"
                                                    style={{ marginBottom: '8px', padding: '4px 3px' }}
                                                    onClick={sortColumnDirChange}
                                                    disabled={isBtnDisabled}
                                                    className="svgIconButton"
                                                >
                                                    <SwapVertIcon style={{ fontSize: '18px' }} />
                                                </KendoReactButton>
                                                <ListBoxToolbar
                                                    tools={[
                                                        "moveUp",
                                                        "moveDown",
                                                        "transferTo",
                                                        "transferFrom",
                                                        "transferAllTo",
                                                        "transferAllFrom",
                                                        "remove"
                                                    ]}
                                                    data={colMultiFilter.sortColumnsData}
                                                    dataConnected={colMultiFilter.movTableColumns}
                                                    onToolClick={e => {
                                                        sortColumnsOnToolBarClick(e);
                                                    }}
                                                />
                                            </KendoTooltip>
                                        </div>
                                    );
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "50%"  }}>
                            <Typography
                                variant="body2"
                                gutterBottom
                                sx={{ color: "primary.main", fontWeight: "bold" }}
                            >
                                Columns Of Table
                            </Typography>
                            <ListBox
                                style={{ height: `${listBoxHeight - 280}px`, width: "100%" }}
                                data={colMultiFilter.movTableColumns}
                                textField="title"
                                selectedField={SELECTED_FIELD}
                                onItemClick={e =>
                                    sortColumnsOnItemClick(
                                        e,
                                        "movTableColumns",
                                        "sortColumnsData"
                                    )
                                }
                                onDragStart={sortColumnsOnDragStart}
                                onDrop={sortColumnsOnDrop}
                            />
                        </Box>
                    </Stack>
                </Grid>

                <WindowActionsBar >
                    <Button
                        variant="contained"
                        onClick={saveSortColumnsData}
                        size="small"
                    >
                        OK
                    </Button>
                    <Button variant="outlined" onClick={clearSettings} size="small">
                        Clear All
                    </Button>
                </WindowActionsBar>
            </Window>}

            {/* open modal for current sortKey view */}
            {openModalCurSortKey && <WindowComponent title={"Save Current Sort Key Data"} visible={openModalCurSortKey} initialWidth={430} initialHeight={230} minWidth={430} minHeight={230} onClose={closePopUpSaveSortKey} dataComponent={SaveCurrentSortKeyData} actionButtons={<RenderActionButtons />} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}

            {/* open delete confirmation modal for current sortKey view  */}
            {openDeleteConfirmationModal && <WindowComponent title={"Delete Confirmation"} visible={openDeleteConfirmationModal} initialWidth={400} initialHeight={210} minWidth={400} minHeight={210} onClose={closeDeleteConfirmationModal} dataComponent={DeleteConfirmationComponent} actionButtons={<RenderActionButtons flag="deleteConfirmModal"/>} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}

            <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose}/>
        </>
    );
}

export default SortColumnChooserPopUp;